import React from 'react';
import { shallow } from 'enzyme';
import DocumentIcon from "../DocumentIcon";

describe('#DocumentIcon', () => {
  let props, wrapper;

  beforeAll(() => {
    props = {
      loading: true,
      color: 'black',
      fontSize: '12px',
      height: '20px',
      width: '30px'
    };
    wrapper = shallow(<DocumentIcon {...props} />);
  });

  it('render with prop values', () => {
    const wrapperProps = wrapper.props();

    expect(wrapper).toBeTruthy();
    expect(wrapperProps.loading).toEqual(props.loading);
    expect(wrapperProps.color).toEqual(props.color);
    expect(wrapperProps.fontSize).toEqual(props.fontSize);
    expect(wrapperProps.height).toEqual(props.height);
    expect(wrapperProps.width).toEqual(props.width);
    expect(wrapperProps.className).toEqual('fa fa-circle-o-notch');
  });
});
